import Vue from 'vue'
import Router from 'vue-router'
import Tag from '@/views/Tag'
import Contact from '@/views/Contact'
import Project from '@/views/Project'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path:'/',
      redirect: '/selected'
    },
    {
      path: '/contact',
      component: Contact
    },
    { 
      path: '/:tag', 
      component: Tag,
      children: [
        {
          path: '',
          name: 'tag',
          component: Tag
        },
        { 
          path: ':project',
          name: 'project',
          component: Project 
        }
      ]
    }
  ]
})


